import anime from 'animejs'
export default class EntryCollection {
  constructor(el) {
    this.el = el
    this.setVariables()
    this.init()
  }

  setVariables() {
    this.triggers = [...this.el.querySelectorAll('[data-trigger]')]
    this.targets = [...this.el.querySelectorAll('[data-target]')]
    this.targetActiveCls = 's-active'
    this.targetInactiveCls = 'hidden'
    this.triggerActiveCls = 'bg-primary'
  }

  init() {
    this.triggers.forEach(link => {
      link.addEventListener('click', this.handleClick)
    })
    this.handleSetTargets()
  }

  handleClick = e => {
    e.preventDefault()
    let trigger = e.target
    if (!trigger.classList.contains(this.triggerActiveCls)) {
      this.triggers.forEach(trigger => {
        trigger.classList.remove(this.triggerActiveCls)
      })
      this.handleActive(trigger.dataset.trigger)
      trigger.classList.add(this.triggerActiveCls)
    }
  }

  handleActive(id) {
    this.targets.forEach(target => {
      if (target.dataset.target === id) {
        target.classList.add(this.targetActiveCls)
        target.classList.remove(this.targetInactiveCls)
      } else {
        target.classList.remove(this.targetActiveCls)
        target.classList.add(this.targetInactiveCls)
      }
    })
  }

  handleSetTargets() {
    this.targets.forEach((target, index) => {
      if (index !== 0) {
        target.classList.add(this.targetInactiveCls)
      }
    })
  }
}
